module.exports = __webpack_public_path__ + "img/arrow_02_feature1.4f45a9df.svg";